<template>
  <div class="multi-switcher">
    <div
      v-for="(option, index) of options"
      class="multi-switcher-item"
      :key="'multi-switcher-option-' + index">
      <label>
        <switcher
          :value="selectedValues.indexOf(option.id) !== -1"
          :key="'selected-values-switcher-' + option.id"
          @click.native="toggleSwitcher(option.id)" />
        <span>
          {{ translate('parameterValues', option.id, 'value', option.value) }}

          <small v-if="showAdditionalPrices && paymentsEnabled && option.price !== '0.00' && (userCanSeeFullPaymentsData || userCanSeeLimitedPaymentsData)">
            {{ getFormattedPrice(option.price, currency) }}
          </small>
        </span>
      </label>
    </div>
  </div>
</template>

<script>
import Configuration from './../mixins/Configuration';
import CurrencyUtils from './../helpers/CurrencyUtils';
import UserTypes from './../mixins/UserTypes';

export default {
  name: 'multi-switcher',
  mixins: [
    Configuration,
    UserTypes
  ],
  props: {
    options: {
      type: Array
    },
    value: {
      default: () => [],
      type: Array
    },
    showAdditionalPrices: {
      default: true,
      type: Boolean
    },
    currency: {
      default: 'PLN',
      type: String
    }
  },
  data () {
    return {
      selectedValues: []
    };
  },
  watch: {
    value (newValue, oldValue) {
      this.selectedValues = newValue.slice();
    }
  },
  mounted () {
    this.selectedValues = this.value.slice();
  },
  methods: {
    toggleSwitcher (value) {
      if (this.selectedValues.indexOf(value) === -1) {
        this.selectedValues.push(value);
      } else {
        let indexToRemove = this.selectedValues.indexOf(value);
        this.selectedValues.splice(indexToRemove, 1);
      }

      this.$emit('input', this.selectedValues);
    },
    getFormattedPrice (price, currency) {
      if (price > 0) {
        return CurrencyUtils.getQuote(price, currency);
      }

      return CurrencyUtils.getQuote(price, currency);
    },
    translate (type, key, fieldName = false, defaultPhrase = '') {
      return this.$parent.$parent.translate(type, key, fieldName, defaultPhrase);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.multi-switcher {
  max-width: 66.666666%;

  &-item {
    padding: .5rem 0;

    label {
      align-items: center;
      display: flex;

      .switcher {
        margin: 0 1rem 0 0;
      }

      span {
        width: calc(100% - 5rem);
      }

      small {
        color: $color-text-light;
        margin-left: 1rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/MultiSwitcher.vue